<template>
  <div v-if="show">
    <div class="entry-float-header">
      <span  v-html="$root.t('entry:sidebar:integrations')"></span>
    </div>
    <template v-for="int in values">
        <div v-if="$root.categories.integration_byid[int[1]] && int[0]">
            <div class="entry-float-title">
                <a class="decorated" :href="$root.categories.integration_byid[int[1]].Data.url.Content.replace('[:id]', int[0])" target="_blank">{{$root.categories.integration_byid[int[1]].Data.name.Content[$root.language]}}</a>
                <a v-on:click="visible == int[1] ? visible = false : visible = int[1]" class="info" :class="{'info-active': visible == int[1]}">?</a>
            </div>
            <transition name="entry-block">
                <div class="entry-float-sidebar-results-multiline" v-if="visible == int[1]">
                    <span v-html="$root.categories.integration_byid[int[1]].Data.beschreibung.Content[$root.language]"></span>
                </div>
            </transition>
        </div>
    </template>
  </div>
</template>


<script>

export default {
  name: 'Integrations',
  props: ['values'],
  data() {
    return {
        visible: false,
        show: false
    }
  },
  async mounted() {
    this.show = false;
    try {
      this.values.forEach(int => {
        if (this.$root.categories.integration_byid[int[1]] && int[0]) {
          this.show = true;
        }
      });
    } catch (error) {
      console.warn(error)
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';
.entry-float-title {
  .info {
      @include smallfont();
      line-height: 1em;
      padding: 0.15em;
      border-radius: 50%; 
      border: 1px solid; 
      height: 1.25em; 
      float: right; 
      display: inline-block; 
      width: 1.25em;
      text-align: center;
      cursor: pointer;
      &-active {
        background: black;
        color: white;
        border-color: black;
      }
  }
}
.entry-float-sidebar-results-multiline {
    margin-bottom: $padding;

    span {
        display: block;
        padding-top: $padding / 2;
        @include smallfont();
        p {
            padding: 0;
            margin: 0;
        }
    }
}


</style>
